module.exports = "<p>\r\n\r\n  Welcome {{name}}\r\n\r\n</p>\r\n\r\n<ul>\r\n  <li *ngFor=\"let item of values\">{{ item.naam }}</li>\r\n</ul>\r\n\r\n<a href=\"javascript:void(0);\" (click)=\"signout();\">signout</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/protected/protected.component.html
// module id = ./src/app/protected/protected.component.html
// module chunks = main